import { CommonModule } from '@angular/common';
import { SingleDatePickerModule } from 'Angular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { LoadingModalModule } from 'Angular/features/components/modals/loading-modal/loading-modal.module';
import { PdfTitleModalModule } from 'Angular/features/components/pdf-title-modal/pdf-title-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { BarChartModule } from 'ChartApp/ts/features/bar-chart/bar-chart.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class AttributionRelativeModule {
}
AttributionRelativeModule.ɵfac = function AttributionRelativeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionRelativeModule)(); };
AttributionRelativeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AttributionRelativeModule });
AttributionRelativeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BarChartModule,
        CommonModule,
        DisabledModule,
        GeneralChartModule,
        HelpModalModule,
        IconModule,
        LoadingModalModule,
        LoadingSymbolModule,
        ModuleUpsellModule,
        PdfTitleModalModule,
        SingleDatePickerModule,
        SingleSelectDropdownModule,
        TooltipModule] });
